import { useContext, useState } from "react"
import ApiContext from "src/provider/API/call-service"
import UserContext from "src/provider/state-manager/userProvider"
import { AbsoluteContainer, AppSpan, Button, CustomContainer, FlexRow, Form, FormGroup, GridContainer, ScreenTitle } from "src/style"
import { AppCenterPopupPlusD3, BanksD3, ManageBeneficiariesD3, Portal, TitleWithBackIconD3 } from "src/component"
import { handleTypeNumberControl } from "src/utils/utility"

export const AddBeneficiaryD3: React.FC<any> = ({close}) => {
    const {user} = useContext(UserContext)
    const {API} = useContext(ApiContext)
    const [input, setInput] = useState({accountNumber: '', beneficiaryBank: '', beneficiaryName: '', beneficiaryBankCode: ''})
    const [fetchedBanks, setFetchedBanks] = useState<any>(null)
    const [benAcct, setBenAcct] = useState('')
    const [view, setView] = useState('manage-beneficiaries')
    const [isLoading, setIsLoading] = useState(false)


    const handleInput = async (e: React.ChangeEvent<HTMLInputElement|HTMLTextAreaElement|HTMLSelectElement>) => {
        let [bankName, acctName] = [input.beneficiaryBank, input.beneficiaryName]
        if (e.target.name === 'accountNumber') {
            if (e.target.value.length === 10) {
                setBenAcct(e.target.value)
                setIsLoading(true)
                const response = await API.getBanks(e.target.value)
                setIsLoading(false)
                if (response) {
                    setFetchedBanks(response)
                    setView('banks')
                }
            }
            else if (e.target.value.length > 10) {
                [bankName, acctName] = ['', '']
                e.target.value = ''
                setBenAcct('')
            }
            else {
                [bankName, acctName] = ['', '']
                setBenAcct(e.target.value)
            }
        }
        setInput({...input, [e.target.name]: e.target.value, beneficiaryBank: bankName, beneficiaryName: acctName})
    }
    
    async function handleProceed(e: React.FormEvent<HTMLButtonElement | HTMLFormElement>) {
        e.preventDefault()
        const payload = {
            accountNumber: benAcct,
            accountName: input.beneficiaryName,
            bankCode: input.beneficiaryBankCode
        }
        await API.addBeneficiary(payload)
        close()
    }

    return (
        <>
            { view === 'add-beneficiary' &&
                <Portal>
                    <AppCenterPopupPlusD3
                        title='Add New Beneficiary' 
                        height={!input.beneficiaryBank ? '27' : '42'} overflow='hidden'
                        contentHeight={!input.beneficiaryBank ? '27' : '42'}
                        maxHeight='85' zIndex='6'
                        close={close}
                        back={() => setView('manage-beneficiaries')} 
                    >
                        { (isLoading) &&
                            <AbsoluteContainer top='0' left='0' zIndex='3' width='100' sizeUnit='%' height="full" radius="2">
                                <GridContainer height='100' hUnit="%" bgColor='rgba(255, 255, 255, 0.5)'>
                                    <AppSpan textSize='4' color='#0D968F' className='fa fa-spinner fa-spin' />
                                </GridContainer>
                            </AbsoluteContainer> 
                        }
                        <TitleWithBackIconD3 title='Add New Beneficiary' backMethod={() => setView('manage-beneficiaries')}/>
                        <CustomContainer>
                            <Form onSubmit={handleProceed}>
                                <FormGroup>
                                    <label>Account Number</label>
                                    <input 
                                        placeholder='Enter Account Number' 
                                        name='accountNumber'
                                        type='number'
                                        value={benAcct || input.accountNumber}
                                        onChange={handleInput}
                                        onKeyDown={handleTypeNumberControl}
                                        onKeyUp={handleTypeNumberControl}
                                        autoComplete="off"
                                        required
                                    />
                                </FormGroup>
                                { input.beneficiaryBank &&
                                    <>
                                        <FormGroup>
                                            <label>Bank</label>
                                            <input 
                                                name='beneficiaryBank'
                                                value={input.beneficiaryBank}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                disabled
                                                required
                                            />
                                        </FormGroup>
                                        <FormGroup>
                                            <label>Account Name</label>
                                            <input 
                                                name='beneficiaryName'
                                                value={input.beneficiaryName}
                                                onChange={handleInput}
                                                autoComplete="off"
                                                disabled
                                                required
                                            />
                                        </FormGroup>
                                    </>
                                }
                                <CustomContainer topMargin='2.5'>
                                    <Button 
                                        width='100' sizeUnit="%" height='4.4' 
                                        borderColor='#0D968F' hoverBgColor='#fff' 
                                        hoverColor='#0D968F' titleSize='1.4'
                                    >
                                        Add New Beneficiary
                                    </Button>
                                </CustomContainer>
                            </Form>
                        </CustomContainer>
                    </AppCenterPopupPlusD3>
                </Portal>
            }
            { view === 'manage-beneficiaries' &&
                <ManageBeneficiariesD3
                    close={close}
                    next={() => setView('add-beneficiary')}
                />
            }
            { view === 'banks' &&
                <Portal forcePortal={true}>
                    <BanksD3
                        close={close}
                        formData={{...input, beneficiaryAccount: benAcct, senderAccount: user.userInfo?.profileInfo?.primaryAccount}}
                        handleSelect={setInput}
                        bankData={fetchedBanks}
                        back={() => setView('add-beneficiary')}
                        next={() => setView('add-beneficiary')}
                    />
                </Portal>
            }
        </>
    )
}